import { Preset } from '@shared/components/daterange-picker/daterange-picker-const';

export type DateRangePreset =
  | 'Today'
  | 'This Week'
  | 'This Month'
  | 'This Year'
  | 'YTD'
  | 'Yesterday'
  | 'Last Week'
  | 'Last Month'
  | 'Last Year'
  // Scorecard
  | 'Monthly'
  | 'Trailing 3 Months'
  | 'Trailing 6 Months'
  | 'Trailing 12 Months'
  // Compat layer for new daterange picker (dynamic preset system)
  | 'Week to Date'
  | 'Month to Date'
  | 'Quarter to Date'
  | 'This Quarter'
  | 'Last Quarter';

export const scorecardDateRangePresets = ['Monthly', 'Trailing 3 Months', 'Trailing 6 Months'];

export const DATERANGE_PRESET_TO_PRESET_ID_WITH_MODIFIER: Record<DateRangePreset, Preset | null> = {
  Today: { id: 'this', modifier: 'day' },
  'This Week': { id: 'this', modifier: 'week' },
  'This Month': { id: 'this', modifier: 'month' },
  'This Year': { id: 'this', modifier: 'year' },
  YTD: { id: 'toDate', modifier: 'year' },
  Yesterday: { id: 'last', modifier: 'day' },
  'Last Week': { id: 'last', modifier: 'week' },
  'Last Month': { id: 'last', modifier: 'month' },
  'Last Year': { id: 'last', modifier: 'year' },
  Monthly: null,
  'Trailing 3 Months': null,
  'Trailing 6 Months': null,
  'Trailing 12 Months': null,
  'Week to Date': { id: 'toDate', modifier: 'week' },
  'Month to Date': { id: 'toDate', modifier: 'month' },
  'Quarter to Date': { id: 'toDate', modifier: 'quarter' },
  'This Quarter': { id: 'this', modifier: 'quarter' },
  'Last Quarter': { id: 'last', modifier: 'quarter' },
};
